import { render, staticRenderFns } from "./ScanCode.vue?vue&type=template&id=4b96bdc6&"
import script from "./ScanCode.vue?vue&type=script&lang=js&"
export * from "./ScanCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports